exports["BG"] = require("./BG.js");
exports["BE"] = require("./BE.js");
exports["PT"] = require("./PT.js");
exports["HU"] = require("./HU.js");
exports["CH"] = require("./CH.js");
exports["FI"] = require("./FI.js");
exports["IT"] = require("./IT.js");
exports["HR"] = require("./HR.js");
exports["LV"] = require("./LV.js");